var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-bq-cms-wrap cms-wrap"},[(_vm.$route.params.key === 'home' || _vm.$route.params.key === 'home-mb')?[_c('QuickRegister')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }